import { cn } from '@skupreme/shared/ui';

export const stepBannerTypes = {
  DANGER: 'DANGER',
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
} as const;

export type StepBannerType = keyof typeof stepBannerTypes;

type StepBannerProps = {
  bannerMessage?: string | React.ReactNode;
  bannerType?: StepBannerType;
};

const TONES: Record<StepBannerType, string> = {
  DANGER: 'sk:border-danger sk:bg-danger-bg',
  SUCCESS: 'sk:border-success sk:bg-success-bg',
  INFO: 'sk:border-info sk:bg-info-bg',
};

export function StepBanner({ bannerMessage, bannerType }: StepBannerProps) {
  if (!bannerMessage) return null;

  return (
    <div
      className={cn(
        'sk:mx-4 sk:mb-0 sk:rounded-[5px] sk:border sk:border-solid sk:p-2.5 sk:text-fg',
        TONES[bannerType ?? stepBannerTypes.INFO],
      )}
    >
      {bannerMessage}
    </div>
  );
}
